import { apiResourceUrl } from "@ploy-lib/core";
import { v4 as uuidv4 } from "uuid";
import { BaseCamelCasedResource } from "./BaseResource";
class GuarantorResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.customerId = null;
        this.customerNumber = null;
        this.__id = uuidv4();
        this.customerTypeId = "";
        this.customerCompanyNumber = "";
        this.customerNumberCombined = "";
        this.customerName = "";
        this.comment = "";
        this.phoneMobile = "";
        this.email = "";
        this.guarantorAmount = "";
        this.guarantorEmployer = "";
        this.guarantorGrossIncome = "";
        this.address = "";
        this.addressCity = "";
        this.addressZip = "";
        this.guarantorType = "";
    }
    pk() {
        return `${this.customerId || this.__id}`;
    }
}
GuarantorResource.urlRoot = apiResourceUrl("guarantor");
export { GuarantorResource };
//# sourceMappingURL=GuarantorResource.js.map